import type { PropsWithChildren } from 'react';
import { Title } from './title';

type PageTitleProps = {
  className?: string;
  id?: string;
};

export const PageTitle = ({ children, className, id }: PropsWithChildren<PageTitleProps>) => (
  <header className={className} id={id}>
    <Title className="text-xl leading-tight">{children}</Title>
  </header>
);

export default PageTitle;
